const s = require("./login.module.scss");

import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ApplicationState } from "core/app";
import httpService from "core/infrastructure/http";
import {PageList} from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}

type PageProps = OwnState & WithTranslation;

export const page_config: PageList =
{
    apiUrl: "",
    webUrl: "jaoLogin",
    menu: "", //no menu link should be created for this page
    apiType: "system",
    title: "common:titleMonitoring",
    response: "",
    dto: "",
    parameters: "",
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

const Page = ({ t, applicationState }: PageProps) => {

    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const doLogon = () => {
        if (password == null || password === "" || password === "empty") {
            setError("Password cannot be empty.");
            return;
        }
        (async function runAsync() {
            const response = await httpService.apiPost({
                applicationState: applicationState,
                route: applicationState.applicationRoot + "systemLogin",
                query: { username: userName, password: password },
                senderId: "login"
            })();

            if (response.ok) {
                if (response.data.message) {
                    setError(response.data.message);
                } else {
                    setPassword("");
                    window.location.reload(); //refresh the page, so user data will be visible
                }
            } else {
                setError(response.error || t("common:UnknownError"));
            }
        })();
    }
    const doLogoff = () => {
        setUserName(applicationState.userMail);
        (async function runAsync() {
            const response = await httpService.apiPost({
                applicationState: applicationState,
                route: applicationState.applicationRoot + "systemLogoff",
                senderId: "login"
            })();

            if (response.ok) {
                applicationState.changeToken("", "Guest", applicationState.guestToken);
                setError("");
                setPassword("");
            } else {
                setError(response.error || t("common:UnknownError"));
            }
        })();
    }

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange("", false, false, []);
        })();
    }, [applicationState.selectedDate]);

    return applicationState.userRole === "JaoUser" || applicationState.userRole === "JaoAdmin" || applicationState.userRole === "Licquid" ?
        (
            <div style={{ flex: "1", position: "relative", overflow: "auto" }}>
                <h3 className={s.title}>{t("login:profile")}</h3>
                <form className={s.container} id="logoffForm" onSubmit={e => { e.preventDefault(); doLogoff(); return false; }}>
                    <label htmlFor="user" style={{ marginBottom: "0px" }}>{t("login:user")}</label>
                    <input type="text" name="user" value={applicationState.userMail} disabled />
                    <br />

                    <label htmlFor="role" style={{ marginBottom: "0px" }}>{t("login:role")}</label>
                    <input type="text" name="role" value={applicationState.userRole} disabled />
                    <br />

                    <input type="submit" className={s.submitButton} value="Log Off" />

                    {error || (<div className={s.error}>{error}</div>)}
                </form>
            </div >
        )
        : (
            <div style={{ flex: "1", position: "relative", overflow: "auto" }}>
                <h3 className={s.title}>{t("login:login")}</h3>
                <form className={s.container} id="loginForm" onSubmit={e => { e.preventDefault(); doLogon(); return false; }}>
                    <label htmlFor="user" style={{ marginBottom: "0px" }}>{t("login:user")}</label>
                    <input type="text" name="user" value={userName} onChange={e => setUserName(e.currentTarget.value)} />
                    <br />

                    <label htmlFor="password" style={{ marginBottom: "0px" }}>{t("login:password")}</label>
                    <input type="password" name="password" value={password} onChange={e => setPassword(e.currentTarget.value)} />
                    <br />

                    <input type="submit" className={s.submitButton} value="Log On" />

                    {error || (<div className={s.error}>{error}</div>)}
                </form>
            </div >
        );
}

export default withTranslation("login")(Page);
